import { useEffect } from 'react';
import { marketDataRecheckDelayMs } from 'pages/Intelligence/DailyNav/components/ReportDialog/ReportDialog.utils';
import type { DailyNavMarketDataReadiness } from 'pages/Intelligence/DailyNav/daily-nav.api.types';

// Re-asks while market data is in flight. Keyed on `fetchedAt` (the query's dataUpdatedAt), not
// the object: structural sharing hands back the same object when an answer is unchanged.
const useMarketDataRecheck = (
  marketData: DailyNavMarketDataReadiness | null | undefined,
  recheck: () => unknown,
  fetchedAt: number,
  enabled = true
) => {
  useEffect(() => {
    if (!enabled) {
      return undefined;
    }
    const delay = marketDataRecheckDelayMs(marketData);
    if (delay === null) {
      return undefined;
    }
    const timer = setTimeout(() => {
      recheck();
    }, delay);
    return () => clearTimeout(timer);
  }, [enabled, fetchedAt, marketData, recheck]);
};

export default useMarketDataRecheck;
